<template>
  <div class="margin-top-m">
    <div class="schedule-delivery-container grid-container full">
      <div class="grid-x">
        <div class="small-12">
          <h4 class="margin-bottom-xxs">
            {{ ORDER_LOOKUP.scheduleDeliveryText }}
          </h4>
          <p class="margin-bottom-xxs">
            {{ ORDER_LOOKUP.deliveryChangeText }}
          </p>
          <p class="small margin-bottom-s gray-1-color">
            {{ ORDER_LOOKUP.easySchedulingText }}
          </p>
        </div>
        <div class="small-12 medium-5">
          <a
            :href="scheduleDeliveryURL"
            class="primary button button-small expanded small-margin-bottom-m medium-margin-bottom-xl"
            role="button"
            :target="_self"
            @click="scheduleDeliveryURLClicked"
          >
            {{ ORDER_LOOKUP.scheduleDeliveryText }}
          </a>
        </div>
      </div>
    </div>
    <div>
      <h4 class="margin-bottom-xxs">
        {{ ORDER_LOOKUP.deliveryStatusText }}
      </h4>
      <p class="margin-bottom-xs">
        {{ ORDER_LOOKUP.orderArrivalText }}
      </p>
      <p class="margin-bottom-m">
        {{ ORDER_LOOKUP.deliveryStatusNote }}
      </p>
    </div>
    <Notification v-if="furnitureStore.furnitureStatusError" severity="error">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="furnitureStore.furnitureStatusError"></span>
    </Notification>
    <Tabs :tabs="tabs" class="cell large-12 tabs margin-bottom-m" @tab-click="clearFurnitureStatusState">
      <template #v-tab-head-salesCheckForm>
        <div class="tab-head active">
          <span id="salesCheckForm">{{ ORDER_LOOKUP.salesCheckNumberText }}</span>
        </div>
      </template>
      <template #v-tab-panel-salesCheckForm>
        <CheckStatusBySalesCheckForm />
      </template>
      <template #v-tab-head-checkStatusByNameForm>
        <div class="tab-head">
          <span id="checkStatusByNameForm">{{ ORDER_LOOKUP.nameText }}</span>
        </div>
      </template>
      <template #v-tab-panel-checkStatusByNameForm>
        <CheckStatusByNameForm />
      </template>
    </Tabs>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useFurnitureStore } from '@/stores/ppe/useFurnitureStore';
import Tabs from '@atomic-ui/tabs/Tabs.vue';
import Notification from '@atomic-ui/notification/Notification.vue';
import { fireTag } from '@vue-util/tagManager';
import { ORDER_LOOKUP } from 'config';
import CheckStatusBySalesCheckForm from '@/components/ppe/lookup/CheckStatusBySalesCheckForm';
import CheckStatusByNameForm from '@/components/ppe/lookup/CheckStatusByNameForm';
import { PPE_SCHEDULE_DELIVERY_URL } from '#shared/endpoints';

const tabs = ref(['salesCheckForm', 'checkStatusByNameForm']);
const furnitureStore = useFurnitureStore();
const scheduleDeliveryURL = computed(() => PPE_SCHEDULE_DELIVERY_URL);

const clearFurnitureStatusState = async () => {
  await furnitureStore.CLEAR_FURNITURE_STATUS();
};

const scheduleDeliveryURLClicked = () => {
  fireTag('link', {
    ...ORDER_LOOKUP.scheduleDeliveryTag,
  });
};

onMounted(async () => {
  if (!furnitureStore.killSwitch) {
    await furnitureStore.GET_KILLSWITCH();
  }
});
</script>
